<template>
  <sdCards headless>
    <div v-if="isChartLoading" class="sd-spin">
      <a-spin />
    </div>

    <div v-else id="chart">
      <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
    </div>
  </sdCards>
</template>

<script>
import SvgConverter from '@/components/utilities/SvgConverter.vue';

export default {
  components: {
    SvgConverter,
  },
  props: {
    yTitle: {
        type: String,
    },
    dataLabel: {
        type: String
    },
    mainTitle: {
        type: String
    },
    endpoint: {
      type: String,
    },    
  },
  data() {
    return {
      isChartLoading: false,
      series: [
        {
          name: this.dataLabel,
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
        },
        title: {
          text: this.mainTitle,
          align: 'left',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [
            this.$t("common.january"),
            this.$t("common.febuary"),
            this.$t("common.march"),
            this.$t("common.april"),
            this.$t("common.may"),
            this.$t("common.june"),
            this.$t("common.july"),
            this.$t("common.august"),
            this.$t("common.september"),
            this.$t("common.october"),
            this.$t("common.november"),
            this.$t("common.december"),
          ],
        },
        yaxis: {
          title: {
            text: this.yTitle,
          },
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val;
            },
          },
        },
      },
    };
  },
  created() {
      this.getStatistics(this.endpoint);
  },
  methods: {
      getStatistics(param) {
      this.isChartLoading = true;
      this.$appAxios.post(param)
        .then(response => {
          if (response.data.status === true) {
            this.series[0].data = response.data.data;
          }
          this.isChartLoading = false;
        })
        .catch(e => {
        });
    },
  }
};
</script>
